/* eslint-disable linebreak-style */
/* eslint-disable function-paren-newline */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable indent */
/* eslint-disable react/jsx-curly-newline */

import { useHistory } from "react-router-dom";
import { PAGES } from "../../../common/constants/common";
import { Button, Col, Row, Title } from "../../../components/ui";
import { PageNotFoundIcon } from "../../../assets/icons";
import { appInsightsService } from "../../../services/appInsights/appInsights";
import styles from "../errors.module.scss";

const Error404 = () => {
  const location = window.location.href;
  appInsightsService.trackPageView(location);

  const history = useHistory();
    return (
      <Row direction="column">
        <Col>
          <PageNotFoundIcon className={styles.errorIcon} />
        </Col>
        <Col>
          <Title>Page non trouvée</Title>
        </Col>
        <Button
          onClick={() => history.push(PAGES.SIGN_IN)}
        >
          Retour
        </Button>
      </Row>
  );
};

export default Error404;
